/**
 * Gestionnaire d'assets pour Instagram Team
 * Centralise la gestion des chemins vers les images et autres ressources
 */

const ASSETS_BASE_PATH = '/assets';

export const IMAGES = {
  // Logos
  RADIO_CAUSE_COMMUNE_LOGO: `${ASSETS_BASE_PATH}/images/radio-cause-commune-logo.svg`,
  
  // Autres assets peuvent être ajoutés ici
  // FAVICON: `${ASSETS_BASE_PATH}/images/favicon.ico`,
  // DEFAULT_AVATAR: `${ASSETS_BASE_PATH}/images/default-avatar.png`,
};

/**
 * Fonction utilitaire pour obtenir le chemin complet vers un asset
 * @param {string} assetPath - Chemin relatif vers l'asset
 * @returns {string} - Chemin complet vers l'asset
 */
export const getAssetPath = (assetPath) => {
  return `${ASSETS_BASE_PATH}/${assetPath}`;
};

/**
 * Fonction utilitaire pour précharger les images importantes
 * @param {string[]} imagePaths - Tableau des chemins d'images à précharger
 */
export const preloadImages = (imagePaths) => {
  imagePaths.forEach(path => {
    const img = new Image();
    img.src = path;
  });
};

/**
 * Fonction pour obtenir l'URL du logo principal
 * @returns {string} - URL du logo de Radio Cause Commune
 */
export const getMainLogo = () => IMAGES.RADIO_CAUSE_COMMUNE_LOGO;

export default {
  IMAGES,
  getAssetPath,
  preloadImages,
  getMainLogo
}; 